import type { QueryFunctionContext } from '@tanstack/react-query';
import { OrganizationsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { TCall } from 'app/queries/types/TCall';
import type { workspacesKeys } from 'app/queries/workspaces/workspacesKeys';

type TParams = QueryFunctionContext<ReturnType<typeof workspacesKeys.listsByOrganization>>;

export const createFetchOrganizationWorkspacesQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ organizationId }], signal }: TParams) =>
    call(() => cancelOnSignal(OrganizationsService.getOrgWorkspaces({ oid: organizationId }), signal));
